// extracted by mini-css-extract-plugin
export default {"content":"page_apply_content__R7IL8","left":"page_apply_left__+aYXM","right":"page_apply_right__uMnNY"};